import SectionHead from '../SectionHead'
import Card from '../../UI/Card'
import { steps } from '../../data'
import { Link } from 'react-router-dom'
import { GiCrownedHeart } from 'react-icons/gi'

const Steps = () => {
  return (
    <section className="steps">
        <div className="container steps__container">
            <SectionHead sectionName="steps" icon={<GiCrownedHeart />} title="Here's a Quick Breakdown of How to Hire/Commision/Contract/Retain/Engage/Employ/Procure Me as Your Celebrant;" />
            <div className="steps__wrapper">
                {
                    steps.map(({id, icon, title, desc}) => {
                        return (
                            <Card className="steps" key={id}>
                                <span className="steps__icon">{icon}</span>
                                <h4 className="steps__title">{title}:</h4>
                                <p className="steps__desc">{desc}</p>
                            </Card>
                        )
                    })
                }
            </div>
            <Link to="/contact" className="btn lg steps__btn">Request Your Complimentary Consult Today!</Link>
        </div>
    </section>
  )
}

export default Steps